import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useAttachments } from '@/lib/queries';
import { AttachmentsPanel, type AttachmentTarget } from './AttachmentsPanel';

/** Archivos de una unidad o de un proyecto, en una ventana. */
export function AttachmentsDialog({
  target,
  canUpload,
  onClose,
}: {
  target: AttachmentTarget;
  canUpload: boolean;
  onClose: () => void;
}) {
  const { data, isLoading, refetch } = useAttachments(target.entityType, target.entityId);
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="attachments-dialog">
        <DialogHeader>
          <DialogTitle>Archivos · {target.label}</DialogTitle>
          <DialogDescription>
            Planos, fotos y documentos de {target.label}. Los ve todo el equipo con acceso.
          </DialogDescription>
        </DialogHeader>
        <AttachmentsPanel
          items={data?.items}
          isLoading={isLoading}
          targets={[target]}
          canUpload={canUpload}
          refresh={async () => (await refetch()).data?.items}
        />
      </DialogContent>
    </Dialog>
  );
}
